import React from 'react';

import DropdownMenu from 'common/components/header/dropdowns/common/DropdownMenu';
import DropdownMenuItem from 'common/components/header/dropdowns/common/DropdownMenuItem';

const DropdownChildren: React.FC<IMenuProps> = ({
  anchorEl,
  handleClose,
  dropdownData,
  ...other
}) => {
  return (
    <DropdownMenu
      anchorEl={anchorEl}
      handleClose={handleClose}
      {...other}
    >
      {dropdownData &&
        dropdownData.map(({ id, ...props }) => (
          <DropdownMenuItem
            key={id}
            handleClose={handleClose}
            {...props}
          />
        ))}
    </DropdownMenu>
  );
};

export default DropdownChildren;
